


































































import Vue from 'vue'
import { userAvatarImage } from '../../helper/constants'
import { getThemeClasses, getMobileTheme } from '../../helper'
export default Vue.extend({
  props: {
    instructor: {
      type: Object
    },
    progressColor: {
      type: String,
      default: ''
    },
    newYorkTheme: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      defaultValues: {
        heading: 'Instructor',
        name: 'Instructor Name',
        title: 'Instructor',
        headshot: userAvatarImage,
        bio:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras sed sapien quam. Sed dapibus est id enim facilisis, at posuere turpis adipiscing. Quisque sit amet dui dui.'
      },
      instructorTitleClass: {
        'product-overview': 'primaryStyle instructor-title',
        'post-overview': 'lessonPrimaryStyle lesson-instructor-title',
        'in-app-upsell': 'upsell-instructor-title'
      },
      instructorBioClass: {
        'product-overview': 'secondaryStyle instructor-bio',
        'post-overview': 'lessonSecondaryStyle lesson-instructor-bio',
        'in-app-upsell': 'upsell-instructor-bio'
      },
      instructorNameClass: {
        'product-overview': 'secondaryStyle instructor-name',
        'post-overview': 'lessonSecondaryStyle lesson-instructor-name',
        'in-app-upsell': 'upsell-instructor-name'
      },
      instructorHeadingClass: {
        'product-overview': 'instructor-heading',
        'post-overview': 'lesson-instructor-heading',
        'in-app-upsell': 'upsell-instructor-heading'
      },
      instructorCardClass: {
        'product-overview': 'instructor-card',
        'post-overview': 'lesson-instructor-card',
        'in-app-upsell': 'upsell-instructor-card'
      }
    }
  },
  computed: {
    newMobileScreens(): booolean {
      return this.$store.getters.newMobileScreens
    }
  },
  methods: {
    getThemeClasses,
    getMobileTheme
  }
})
